export const testIDs = {
    common: {
        container: "common-container",
    },
    overview: {
        headings: {
            tasks: "overview-heading-tasks",
            favourites: "overview-heading-favourites",
            insights: "overview-heading-insights",
        },
        tasks: {
            certificatesExpiringIn30Days: "overview-tasks-certificatesExpiringIn30Days",
            pendingCertificateSearch: "overview-tasks-pendingCertificateSearch",
            customersMissingCertificates: "overview-tasks-customersMissingCertificates",
            addSignature: "overview-tasks-addSignature",
            defineExemption: "overview-tasks-defineExemption",
        },
        favourites: {
            addCustomer: "overview-favourites-addCustomer",
            addVendor: "overview-favourites-addVendor",
            viewAllCustomers: "overview-favourites-viewAllCustomers",
            viewAllVendors: "overview-favourites-viewAllVendors",
            addCertificate: "overview-favourites-addCertificate",
            requestCertificates: "overview-favourites-requestCertificates",
            viewAllCertificates: "overview-favourites-viewAllCertificates",
            viewAllVendorCertificates: "overview-favourites-viewAllVendorCertificates",
            reports: "overview-favourites-reports",
            retail: "overview-favourites-retail",
            jobs: "overview-favourites-jobs",
        },
    },
    review: {
        certificateHeading: "review-certificateHeading",
        certificateFilename: "review-certificateFilename",
        exmptPercentInput: "review-exmptPercent-input",
        exmptPercentLabel: "review-exmptPercent-label",
        avsBanner: {
            success: "review-avsBanner-success",
            reviewRequired: "review-avsBanner-reviewRequired",
            missingFields: "review-avsBanner-missingFields",
            missingField: "review-avsBanner-missingField",
            multipleMissingFields: "review-avsBanner-multipleMissingFields",
            multipleIssues: "review-avsBanner-multipleIssues",
            invalidTaxId: "review-avsBanner-invalidTaxId",
            error: "review-avsBanner-error",
            mismatch: "review-avsBanner-mismatch",
        },
        avsScannerDialog: {
            container: "review-avsScannerDialog-container",
            header: "review-avsScannerDialog-header",
            body: "review-avsScannerDialog-body",
            skipButton: "review-avsScannerDialog-skipButton",
            footer: "review-avsScannerDialog-footer",
        },
        revalidate: {
            button: "review-revalidate-button",
            dialog: "revalidate-confirm-dialog",
            cancelButton: "revalidate-cancel-button",
            confirmButton: "revalidate-confirm-button",
        },
    },
    campaign: {
        bulkRequests: {
            request: "campaign-bulkRequests-request",
            loader: "campaign-bulkRequests-loader",
            grid: "campaign-bulkRequests-grid",
            pagination: "campaign-bulkRequests-pagination",
        },
        requestDetails: {
            backButton: "campaign-requestDetails-backButton",
            searchBar: "campaign-requestDetails-searchBar",
            export: "campaign-requestDetails-export",
            grid: "campaign-requestDetails-grid",
            loader: "campaign-requestDetails-loader",
            pagination: "campaign-requestDetails-pagination",
            editButton: "campaign-requestDetails-editButton",
            cancelButton: "campaign-requestDetails-cancelButton",
            saveButton: "campaign-requestDetails-saveButton",
            deleteButton: "campaign-requestDetails-deleteButton",
            addRoundDialog: "campaign-requestDetails-addRoundDialog",
            addRoundDialogSendDate: "campaign-requestDetails-addRoundDialogSendDate",
            addRoundDialogReturnDate: "campaign-requestDetails-addRoundDialogReturnDate",
            addRoundDialogDeliveryMethod: "campaign-requestDetails-addRoundDialogDeliveryMethod",
            addRoundButton: "campaign-requestDetails-addRoundButton",
            deliveryMethodLabel: "campaign-requestDetails-deliveryMethodLabel",
        },
        singleRequests: {
            request: "campaign-singleRequests-request",
            searchBar: "campaign-singleRequests-searchBar",
            loader: "campaign-singleRequests-loader",
            grid: "campaign-singleRequests-grid",
            pagination: "campaign-singleRequests-pagination",
        },
    },
    customerSearch: {
        heading: "customerSearch-heading",
        switchToJobs: "customerSearch-switchToJobs",
        reports: "customerSearch-reports",
        filtersButton: "customerSearch-filtersButton",
        searchBar: "customerSearch-searchBar",
        manageColumns: "customerSearch-manageColumns",
        moreActions: {
            button: "customerSearch-moreActions-button",
            dropdown: "customerSearch-moreActions-dropdown",
            import: "customerSearch-moreActions-import",
            export: "customerSearch-moreActions-export",
            save: "customerSearch-moreActions-save",
            delete: "customerSearch-moreActions-delete",
            updateLabels: "customerSearch-moreActions-updateLabels",
        },
        requestCertificates: "customerSearch-requestCertificates",
        addCustomerButton: "customerSearch-addCustomerButton",
        filtersPanel: {
            container: "customerSearch-filtersPanel-container",
            viewSavedReports: "customerSearch-filtersPanel-viewSavedReports",
            selectCompanyGroups: "customerSearch-filtersPanel-selectCompanyGroups",
            otherFilters: "customerSearch-filtersPanel-otherFilters",
            exemptionOverrideToggle: "customerSearch-filtersPanel-exemptionOverrideToggle",
            exemptionOverrideSection: "customerSearch-filtersPanel-exemptionOverrideSection",
        },
        grid: "customerSearch-grid",
        pagination: "customerSearch-pagination",
        loader: "customerSearch-loader",
    },
    vendorSearch: {
        heading: "vendorSearch-heading",
        reports: "vendorSearch-reports",
        filtersButton: "vendorSearch-filtersButton",
        searchBar: "vendorSearch-searchBar",
        manageColumns: "vendorSearch-manageColumns",
        moreActions: {
            button: "vendorSearch-moreActions-button",
            dropdown: "vendorSearch-moreActions-dropdown",
            import: "vendorSearch-moreActions-import",
            export: "vendorSearch-moreActions-export",
            save: "vendorSearch-moreActions-save",
        },
        addVendorButton: "vendorSearch-addVendorButton",
        filtersPanel: {
            container: "vendorSearch-filtersPanel-container",
            viewSavedReports: "vendorSearch-filtersPanel-viewSavedReports",
            otherFilters: "vendorSearch-filtersPanel-otherFilters",
        },
        grid: "vendorSearch-grid",
        pagination: "vendorSearch-pagination",
        loader: "vendorSearch-loader",
    },
    jobSearch: {
        heading: "jobSearch-heading",
        searchBar: "jobSearch-searchBar",
        createJobButton: "jobSearch-createJobButton",
        grid: "jobSearch-grid",
        pagination: "jobSearch-pagination",
        loader: "jobSearch-loader",
    },
    certificateSearch: {
        heading: "certificateSearch-heading",
        reports: "certificateSearch-reports",
        filtersButton: "certificateSearch-filtersButton",
        searchBar: "certificateSearch-searchBar",
        manageColumns: "certificateSearch-manageColumns",
        moreActions: {
            button: "certificateSearch-moreActions-button",
            dropdown: "certificateSearch-moreActions-dropdown",
            addCertificate: "certificateSearch-moreActions-addCertificate",
            import: "certificateSearch-moreActions-import",
            export: "certificateSearch-moreActions-export",
            save: "certificateSearch-moreActions-save",
            exportImages: "certificateSearch-moreActions-exportImages",
            delete: "certificateSearch-moreActions-delete",
            update: "certificateSearch-moreActions-update",
            resync: "certificateSearch-moreActions-resync",
        },
        requestCertificates: "certificateSearch-requestCertificates",
        filtersPanel: {
            container: "certificateSearch-filtersPanel-container",
            viewSavedReports: "certificateSearch-filtersPanel-viewSavedReports",
            selectCompanyGroups: "certificateSearch-filtersPanel-selectCompanyGroups",
            otherFilters: "certificateSearch-filtersPanel-otherFilters",
        },
        grid: "certificateSearch-grid",
        pagination: "certificateSearch-pagination",
        loader: "certificateSearch-loader",
        relationshipDialog: {
            container: "certificateSearch-relationshipDialog-container",
            table: "certificateSearch-relationshipDialog-table",
            doneButton: "certificateSearch-relationshipDialog-doneButton",
        },
        relationshipColumn: {
            cell: "certificateSearch-relationshipColumn-cell",
            link: "certificateSearch-relationshipColumn-link",
            directIcon: "certificateSearch-relationshipColumn-directIcon",
            indirectIcon: "certificateSearch-relationshipColumn-indirectIcon",
        },
    },
    pendingCertificateSearch: {
        heading: "pendingCertificateSearch-heading",
        reports: "pendingCertificateSearch-reports",
        filtersButton: "pendingCertificateSearch-filtersButton",
        searchBar: "pendingCertificateSearch-searchBar",
        manageColumns: "pendingCertificateSearch-manageColumns",
        moreActions: {
            button: "pendingCertificateSearch-moreActions-button",
            dropdown: "pendingCertificateSearch-moreActions-dropdown",
            assignCertificate: "pendingCertificateSearch-moreActions-assignCertificate",
            releaseCertificates: "pendingCertificateSearch-moreActions-releaseCertificates",
            delete: "pendingCertificateSearch-moreActions-delete",
            export: "pendingCertificateSearch-moreActions-export",
            exportImages: "pendingCertificateSearch-moreActions-exportImages",
            accept: "pendingCertificateSearch-moreActions-accept",
            save: "pendingCertificateSearch-moreActions-save",
            changeBucket: "pendingCertificateSearch-moreActions-changeBucket",
        },
        uploadZip: "pendingCertificateSearch-uploadZip",
        addCertificate: "pendingCertificateSearch-addCertificate",
        filtersPanel: {
            container: "pendingCertificateSearch-filtersPanel-container",
            viewSavedReports: "pendingCertificateSearch-filtersPanel-viewSavedReports",
            assignedTo: "pendingCertificateSearch-filtersPanel-assignedTo",
            escalation: "pendingCertificateSearch-filtersPanel-escalation",
            certificateImagePresent:
                "pendingCertificateSearch-filtersPanel-certificateImagePresent",
            buckets: "pendingCertificateSearch-filtersPanel-buckets",
        },
        grid: "pendingCertificateSearch-grid",
        pagination: "pendingCertificateSearch-pagination",
        loader: "pendingCertificateSearch-loader",
    },
    vendorCertificateSearch: {
        heading: "vendorCertificateSearch-heading",
        tabs: "vendorCertificateSearch-tabs",
        certificateSearch: {
            reports: "vendorCertificateSearch-certificateSearch-reports",
            filtersButton: "vendorCertificateSearch-certificateSearch-filtersButton",
            searchBar: "vendorCertificateSearch-certificateSearch-searchBar",
            manageColumns: "vendorCertificateSearch-certificateSearch-manageColumns",
            moreActions: {
                button: "vendorCertificateSearch-certificateSearch-moreActions-button",
                dropdown: "vendorCertificateSearch-certificateSearch-moreActions-dropdown",
                save: "vendorCertificateSearch-certificateSearch-moreActions-save",
                export: "vendorCertificateSearch-certificateSearch-moreActions-export",
            },
            showOnlyActiveCertificates:
                "vendorCertificateSearch-certificateSearch-showOnlyActiveCertificates",
            filtersPanel: {
                container: "vendorCertificateSearch-certificateSearch-filtersPanel-container",
                viewSavedReports:
                    "vendorCertificateSearch-certificateSearch-filtersPanel-viewSavedReports",
                otherFilters: "vendorCertificateSearch-certificateSearch-filtersPanel-otherFilters",
            },
            grid: "vendorCertificateSearch-certificateSearch-grid",
            pagination: "vendorCertificateSearch-certificateSearch-pagination",
            loader: "vendorCertificateSearch-certificateSearch-loader",
        },
        certificatePackages: {
            searchBar: "vendorCertificateSearch-certificatePackages-searchBar",
            createPackage: "vendorCertificateSearch-certificatePackages-createPackage",
            grid: "vendorCertificateSearch-certificatePackages-grid",
            pagination: "vendorCertificateSearch-certificatePackages-pagination",
            loader: "vendorCertificateSearch-certificatePackages-loader",
            noData: "vendorCertificateSearch-certificatePackages-noData",
        },
    },
    generalSettings: {
        uploadLogoButton: "upload-logo-button",
        logoFileInput: "logo-file-input",
        companyLogoImage: "company-logo-image",
        supportedFormatsText: "supported-formats-text",
        previewLogoButton: "preview-logo-button",
        logoPreviewDialog: "logo-preview-dialog",
        logoPreviewImage: "logo-preview-image",
        removeLogoButton: "remove-logo-button",
        deleteLogoDialog: "delete-logo-dialog",
        confirmDeleteLogoButton: "confirm-delete-logo-button",
        cancelDeleteLogoButton: "cancel-delete-logo-button",
        enableLocalJurisdictionCheckbox: "enable-local-jurisdiction-checkbox",
        enableLocalJurisdictionLabel: "enable-local-jurisdiction-label",
        enableAIValidationCheckbox: "enable-ai-validation-checkbox",
        enableAIValidationLabel: "enable-ai-validation-label",
        enableNotificationCheckbox: "enable-notification-checkbox",
        enableNotificationLabel: "enable-notification-label",
        enableOverridesCheckbox: "enable-overrides-checkbox",
        enableOverridesLabel: "enable-overrides-label",
        useCertPercentagesCheckbox: "use-cert-percentages-checkbox",
        useCertPercentagesLabel: "use-cert-percentages-label",
        outgoingEmailValidationHeading: "outgoing-email-validation-heading",
        allowUnsafeTemplateEmailSendCheckbox: "allow-unsafe-template-email-send-checkbox",
        allowUnsafeTemplateEmailSendLabel: "allow-unsafe-template-email-send-label",
    },
    templates: {
        import: {
            heading: "templates-import-heading",
            templateSelector: "templates-import-templateSelector",
            downloadButton: "templates-import-downloadButton",
            uploadArea: "templates-import-uploadArea",
            guidelines: "templates-import-guidelines",
            helpLink: "templates-import-helpLink",
            errorMessage: "templates-import-errorMessage",
            successMessage: "templates-import-successMessage",
            fileInput: "templates-import-fileInput",
            templateDescription: "templates-import-templateDescription",
        },
        customer: {
            basicTemplate: "templates-customer-basicTemplate",
            billToShipToTemplate: "templates-customer-billToShipToTemplate",
            numberChangeTemplate: "templates-customer-numberChangeTemplate",
        },
        vendor: {
            standardTemplate: "templates-vendor-standardTemplate",
            downloadLink: "templates-vendor-downloadLink",
        },
    },
    languageSupportDialog: {
        container: "language-support-dialog",
    },
    shared: {
        resources: {
            heading: "shared-resources-heading",
            description: "shared-resources-description",
            subHeading: "shared-resources-subHeading",
            tiles: {
                taxAnswers: "shared-resources-taxAnswers",
                taxLaws: "shared-resources-taxLaws",
                exemptEntities: "shared-resources-exemptEntities",
                certificateForms: "shared-resources-certificateForms",
                avalaraUniversity: "shared-resources-avalaraUniversity",
            },
            learnMore: "shared-resources-learnMore",
        },
        customerQuickSearch: "shared-customerQuickSearch",
        recordCount: "shared-recordCount",
        noData: "shared-noData",
        noAccess: "shared-noAccess",
        navigation: "shared-navigation",
        header: "shared-header",
        backButton: "back-button",
        pageInfo: "page-info",
        countryLabel: "lbl-country",
        selectCountry: "select-country",
        commentsTab: "shared-commentsTab",
        changeBucketDialog: {
            container: "shared-changeBucketDialog-container",
            select: "shared-changeBucketDialog-select",
            apply: "shared-changeBucketDialog-apply",
            cancel: "shared-changeBucketDialog-cancel",
        },
        certificateLabel: {
            select: "shared-certificateLabel-select",
        },
        selectExposureZone: {
            selectAllButton: "shared-selectExposureZone-selectAllButton",
        },
        invalidReasonsFilter: "shared-invalidReasonsFilter",
        supportingDocumentsPreview: {
            container: "shared-supportingDocumentsPreview-container",
            cancelButton: "shared-supportingDocumentsPreview-cancelButton",
        },
    },
    certificateSettings: {
        autoScanCheckbox: "cert-settings-auto-scan-checkbox",
        autoScanLabel: "cert-settings-auto-scan-label",
        enableAIValidationCheckbox: "cert-settings-ai-validation-checkbox",
        enableAIValidationLabel: "cert-settings-ai-validation-label",
        requireCertImageCheckbox: "cert-settings-require-cert-image-checkbox",
        requireCertImageLabel: "cert-settings-require-cert-image-label",
        certExpressAutoValidCheckbox: "cert-settings-certexpress-auto-valid-checkbox",
        certExpressAutoValidLabel: "cert-settings-certexpress-auto-valid-label",
        requireTaxPayerIdCheckbox: "cert-settings-require-taxpayer-id-checkbox",
        requireTaxPayerIdLabel: "cert-settings-require-taxpayer-id-label",
        prefillEffectiveDateCheckbox: "cert-settings-prefill-effective-date-checkbox",
        prefillEffectiveDateLabel: "cert-settings-prefill-effective-date-label",
        useCertPercentagesCheckbox: "cert-settings-use-cert-percentages-checkbox",
        useCertPercentagesLabel: "cert-settings-use-cert-percentages-label",
        removeExtraRegionsCheckbox: "cert-settings-remove-extra-regions-checkbox",
        removeExtraRegionsLabel: "cert-settings-remove-extra-regions-label",
        saveButton: "cert-settings-save-button",
    },
    settings: {
        /** Main h1 on the settings layout (Exemption certificates) */
        pageHeading: "settings-page-heading",
        addInvalidReasonButton: "add-invalid-reason-button",
        editFaxEmailButton: "edit-fax-email-button",
        deleteFaxEmailButton: "delete-fax-email-button",
        certExpressSettings: {
            notifyInvalidReplacementCheckbox: "notify-invalid-replacement-checkbox",
            invalidReplacementEmail: "invalid-replacement-email-input",
            saveButton: "certexpress-save-button",
        },
        userPreferences: {
            heading: "user-preferences-heading",
            description: "user-preferences-description",
            pendingNotificationCheckbox: "pending-notification-checkbox",
            savePreferencesButton: "save-preferences-button",
            backToSettingsButton: "back-to-settings-button",
        },
        manageExemptionReasons: {
            manageExemptionReasonsDialogs: {
                createUpdateExemptionReason: {
                    exemptReasonName: "exempt-reason-name",
                    exemptReasonDescription: "exempt-reason-desc",
                    entityUseCode: "entity-use-code",
                },
            },
        },
        tabs: {
            certificateRequests: {
                manageTemplatesLink: "manage-templates-link",
                manageFaxEmails: {
                    addEditFaxEmailDialog: {
                        addEditFaxEmailDialog: "add-edit-fax-email-dialog",
                    },
                    deleteFaxEmailDialog: { deleteFaxEmailDialog: "delete-fx-email-dialog" },
                },
            },
        },
    },
    missingCertificatesReport: {
        reportTypeSelector: "missingCertificatesReport-reportTypeSelector",
        filters: {
            container: "missingCertificatesReport-filters-container",
            customerCode: "missingCertificatesReport-filters-customerCode",
            customerName: "missingCertificatesReport-filters-customerName",
            customerState: "missingCertificatesReport-filters-customerState",
            exposureZone: "missingCertificatesReport-filters-exposureZone",
            customerRelationship: "missingCertificatesReport-filters-customerRelationship",
            runReportButton: "missingCertificatesReport-filters-runReportButton",
            emailReportButton: "missingCertificatesReport-filters-emailReportButton",
            exportReportButton: "missingCertificatesReport-filters-exportReportButton",
        },
        grid: "missingCertificatesReport-grid",
        pagination: "missingCertificatesReport-pagination",
        loader: "missingCertificatesReport-loader",
        recordCount: "missingCertificatesReport-recordCount",
        noData: "missingCertificatesReport-noData",
        exportDialog: {
            container: "missingCertificatesReport-exportDialog-container",
            titleInput: "missingCertificatesReport-exportDialog-titleInput",
            exportButton: "missingCertificatesReport-exportDialog-exportButton",
            cancelButton: "missingCertificatesReport-exportDialog-cancelButton",
        },
        scheduleDialog: {
            container: "missingCertificatesReport-scheduleDialog-container",
            scheduleButton: "missingCertificatesReport-scheduleDialog-scheduleButton",
            cancelButton: "missingCertificatesReport-scheduleDialog-cancelButton",
        },
    },
    customerComments: {
        container: "customerComments-container",
        addButton: "customerComments-addButton",
        commentsList: "customerComments-commentsList",
        noComments: "customerComments-noComments",
        commentItem: "customerComments-commentItem",
        commentText: "customerComments-commentText",
        commentAuthor: "customerComments-commentAuthor",
        commentTimestamp: "customerComments-commentTimestamp",
        editButton: "customerComments-editButton",
        deleteButton: "customerComments-deleteButton",
        dialog: {
            container: "customerComments-dialog-container",
            heading: "customerComments-dialog-heading",
            textArea: "customerComments-dialog-textArea",
            saveButton: "customerComments-dialog-saveButton",
            cancelButton: "customerComments-dialog-cancelButton",
            fileInput: "customerComments-dialog-fileInput",
        },
        deleteDialog: {
            container: "customerComments-deleteDialog-container",
        },
    },
    coverLetter: {
        manageTemplatesHeading: "cover-letter-manage-templates-heading",
        titleInput: "cover-letter-title-input",
        subjectInput: "cover-letter-subject-input",
        descriptionInput: "cover-letter-description-input",
        templateLink: "cover-letter-template-link",
        validateAndSaveButton: "cover-letter-validate-and-save-button",
        saveButton: "cover-letter-save-button",
        validateDialog: {
            updateCoverLetterButton: "cover-letter-dialog-update-button",
            saveWithoutUpdatingButton: "cover-letter-dialog-save-without-updating-button",
        },
    },
    job: {
        container: "job-container",
        form: "job-form",
        jobCode: "job-jobCode",
        jobName: "job-jobName",
        region: "job-region",
        createButton: "job-createButton",
        cancelButton: "job-cancelButton",
        addPhaseButton: "job-addPhaseButton",
        phases: {
            container: "job-phases-container",
            phaseContainer: "job-phase-container",
            phaseCode: "job-phase-phaseCode",
            phaseName: "job-phase-phaseName",
            deletePhaseButton: "job-phase-deleteButton",
            collapseButton: "job-phase-collapseButton",
            addTaskButton: "job-phase-addTaskButton",
            tasks: {
                container: "job-tasks-container",
                taskContainer: "job-task-container",
                taskCode: "job-task-taskCode",
                taskName: "job-task-taskName",
                deleteTaskButton: "job-task-deleteButton",
            },
        },
        details: {
            container: "job-details-container",
            certificates: {
                container: "job-details-certificates-container",
                grid: "job-details-certificates-grid",
                pagination: "job-details-certificates-pagination",
                loader: "job-details-certificates-loader",
                noData: "job-details-certificates-noData",
                unlinkButton: "job-details-certificates-unlinkButton",
            },
            customFields: {
                container: "job-details-customFields-container",
                grid: "job-details-customFields-grid",
                tab: "tabpanel-custom-fields",
            },
        },
        unlinkCertificateDialog: {
            container: "job-unlinkCertificateDialog-container",
            unlinkButton: "job-unlinkCertificateDialog-unlinkButton",
            backButton: "job-unlinkCertificateDialog-backButton",
        },
        deleteDialog: {
            container: "job-deleteDialog-container",
            deleteButton: "job-deleteDialog-deleteButton",
            backButton: "job-deleteDialog-backButton",
        },
    },
    ecms: {
        heading: "ecms-heading",
        filtersButton: "ecms-filtersButton",
        grid: "ecms-grid",
        pagination: "ecms-pagination",
        loader: "ecms-loader",
        noData: "ecms-noData",
        filtersPanel: {
            container: "ecms-filtersPanel-container",
            filters: "ecms-filtersPanel-filters",
            companyId: "ecms-filtersPanel-companyId",
            customerName: "ecms-filtersPanel-customerName",
            customerCode: "ecms-filtersPanel-customerCode",
            avaCertId: "ecms-filtersPanel-avaCertId",
            exemptCertId: "ecms-filtersPanel-exemptCertId",
            country: "ecms-filtersPanel-country",
            region: "ecms-filtersPanel-region",
        },
    },
    jobDetails: {
        container: "jobDetails-container",
        heading: "jobDetails-heading",
        jobsSelect: "jobDetails-jobsSelect",
        phasesSelect: "jobDetails-phasesSelect",
        tasksSelect: "jobDetails-tasksSelect",
    },
};
